import { useNavigate,useParams } from "react-router-dom";
import AdminAgenda from "../../pages/dashboard/agenda/AdminAgenda";
import Agenda from "../../pages/dashboard/agenda";
import { useAuth } from "../../hooks/use-auth";

const RoleAgendadRedirect = () => {
  const { user } = useAuth();
  const { tenant } = useParams();

  if (tenant!=globalThis.localStorage.getItem('tenant')|| !user) {
    return <Navigate to="/" />;
  }

  if (user.id_service === 0 && user.access_level === 0) {
    return <AdminAgenda />;
  } else {
    return <Agenda />;
  }
};

export default RoleAgendadRedirect;
